import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=00d2a017&scoped=true"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"
import style0 from "./Jumbotron.vue?vue&type=style&index=0&id=00d2a017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2a017",
  null
  
)

export default component.exports